// Lib
import { FC } from "react";
// Api
// Hooks
// Actions
// Selectors
// Types
// Theme
// Constants
// Helpers
// Utils
// Icons
// Layouts
// Components
import { Select as FormSelect } from "components/Form";
import { Skeleton } from "antd";
// Styled

interface OptionsSelectProps {
  isLoading: boolean;
  canUpdate: boolean;
  width?: number;
  data: any;
  onChange: (value: any) => void;
  options: {
    value: any;
    label: string;
  }[];
}

export const OptionsSelect: FC<OptionsSelectProps> = ({
  isLoading,
  canUpdate,
  data,
  options,
  onChange,
  width,
}) => {
  if (data === undefined && isLoading) {
    return <Skeleton.Input active />;
  }

  if (data === undefined) {
    return null;
  }

  return (
    <FormSelect
      style={{ width: width || 150 }}
      options={options}
      loading={isLoading}
      disabled={!canUpdate}
      value={data}
      onChange={onChange}
    />
  );
};
